import { z } from "zod";
import { dmaModelParameterMetadataDtoSchema } from "./dma-model-parameter-metadata.schema";
export const dmaModelOutputDtoSchema = z.object({
    model: z.string(),
    parameters: dmaModelParameterMetadataDtoSchema.array(),
});
